module.exports = __webpack_public_path__ + "static/media/unm.57219184.webp";